import React, { useState, createRef } from "react";
import "./ExperienceCard.scss";
import ColorThief from "colorthief";

export default function ExperienceCard({ cardInfo, isDark }) {
  const [colorArrays, setColorArrays] = useState([]);
  const imgRef = createRef();

  function getColorArrays() {
    const colorThief = new ColorThief();
    setColorArrays(colorThief.getColor(imgRef.current));
  }

  function rgb(values) {
    return typeof values === "undefined"
      ? null
      : "rgb(" + values.join(", ") + ")";
  }

  const GetDescBullets = ({ descBullets, isDark }) => {
    return descBullets
      ? descBullets.map((item, i) => (
        <li
          key={i}
          className={isDark ? "subTitle dark-mode-text" : "subTitle"}
        >
          {item}
        </li>
      ))
      : null;
  };

  return (
    <div className={isDark ? "experience-card-dark max-w-6xl my-12" : "experience-card max-w-6xl my-12"}>
      <div style={{ background: rgb(colorArrays) }} className="experience-banner">
        <div className="experience-blurred_div"></div>
        <div className="experience-div-company">
          <h5 className="experience-text-company">{cardInfo.company}</h5>
        </div>

        <img
          crossOrigin={"anonymous"}
          ref={imgRef}
          className="h-32 w-32 rounded-full mx-auto absolute left-0 right-0"
          style={{ top: '-5rem' }}
          src={cardInfo.companylogo}
          alt={cardInfo.company}
          onLoad={() => getColorArrays()}
        />
      </div>
      <div className="experience-text-details">
        <h5
          className={
            isDark
              ? "experience-text-role dark-mode-text"
              : "experience-text-role"
          }
        >
          {cardInfo.role}
        </h5>
        <h5
          className={
            isDark
              ? "experience-text-date dark-mode-text italic"
              : "experience-text-date italic"
          }
        >
          {cardInfo.date}
        </h5>
        <p
          className={
            isDark
              ? "subTitle experience-text-desc dark-mode-text font-extrabold"
              : "subTitle experience-text-desc font-extrabold"
          }
        >
          " {cardInfo.desc} "
        </p>
        {
          cardInfo.bullet_format === "heading" ?
            <>
              {cardInfo.descBullets.map(headerInfo => {
                return <div className="my-4">
                  <div>{headerInfo.heading}</div>
                  <ul className="list-disc text-base my-4 px-4">
                    <GetDescBullets descBullets={headerInfo.bullets} isDark={isDark} />
                  </ul>

                </div>
              })}
            </> :
            <ul className="list-disc text-base my-4 px-4">
              <GetDescBullets descBullets={cardInfo.descBullets} isDark={isDark} />
            </ul>
        }
        {
          cardInfo.technologies ? (
            <div className="flex flex-wrap justify-center my-6 text-base">
              {cardInfo.technologies.map((item, i) => (
                <span key={i} style={{ background: rgb(colorArrays) }} className="bg-purple-900 p-1 px-4 rounded-xl m-2 h-8 flex items-center">{item}</span>
              ))}
            </div>) : null
        }
      </div>
    </div>
  );
}
